export const USER_PROFILE_TAB_EMAILS_QA_NAME = 'userProfileTabEmails'
